import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    zIndex: -2,
    top: 0,
    left: 0,
    height: '380px',
    overflow: 'hidden',
    width: '100%',
    background: 'radial-gradient(#412d62, #2e213f)',
  },
  background: {
    height: '100%',
    objectFit: 'cover',
    width: '100%',
  },
  xs: {
    height: '20vh',
  },
  large: {
    height: '500px',
    [theme.breakpoints.down('sm')]: {
      height: '400px',
    },
  },
  regular: {
    height: '350px',
    [theme.breakpoints.down('sm')]: {
      height: '300px',
    },
  },
  small: {
    height: '18vh',
  },
  xl: {
    [theme.breakpoints.down('sm')]: {
      height: '500px',
    },
    [theme.breakpoints.down('xs')]: {
      height: '560px',
    },
    [theme.breakpoints.up('lg')]: {
      height: '700px',
    },
    height: '600px',
  },
  xxl: {
    [theme.breakpoints.down('sm')]: {
      height: '55vh',
    },
    [theme.breakpoints.down('xs')]: {
      height: '80vh',
    },
    height: '100vh',
  },
}))

function Background({
  size,
}: {
  size?: 'xs' | 'small' | 'regular' | 'large' | 'xl' | 'xxl'
}): JSX.Element {
  const classes = useStyles({})
  return (
    <div className={`${classes.root} ${size && classes[size]}`}>
      <img src="/svg/background.svg" className={classes.background} />
    </div>
  )
}

export default Background
